import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { ChangeType } from '@common/prosemirror/tracked-changes/change-type.enum';
import { attrsHaveChange } from '@common/prosemirror/tracked-changes/compare';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class BrSchemaPlugin extends SchemaPlugin {
  nodes = {
    hard_break: {
      inline: true,
      group: 'inline',
      parseDOM: [
        { tag: 'br' },
        { tag: 'mc-br' }
      ],
      toDOM(node) {
        // If there is a remove change then render the <br> as <mc-br> so that there is no actual break in the editor's content
        if (attrsHaveChange(node.attrs, ChangeType.Remove)) {
          const outputSpec = nodeToDOM(node, { tagName: 'mc-br' });
          outputSpec.dom.textContent = ' ';
          return outputSpec;
        } else {
          return nodeToDOM(node);
        }
      },
      tagName: 'br',
      isVoid: true
    }
  } satisfies Record<string, NodeSpec>;
}
